import { Component, OnInit, OnDestroy, Injector } from "@angular/core";
import { SeoAwareBaseComponent } from "../../common-theme/seo/seo-aware-base.component";
import { Subscription } from "rxjs";
import { Block } from "../../common-theme/models/index";
import { BlockHelperService } from "../../common-theme/index";
import { BlocksService } from "../../common-theme/api/index";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-nume1",
  templateUrl: "./nume1.component.html",
  styleUrls: ["./nume1.component.scss"],
})
export class Nume1Component
  extends SeoAwareBaseComponent
  implements OnInit, OnDestroy
{
  public blocks: Block[];
  public block: Block;
  public projectKey: string;
  subscription: Subscription = new Subscription();
  sliders: any[];

  constructor(
    public blockHelper: BlockHelperService,
    public blocksService: BlocksService,
    public route: ActivatedRoute,
    public injector: Injector
  ) {
    super(injector);
  }

  private isProjectLocal(category: string) {
    return !![
      "res02",
      "res04",
      "res05",
      "res06",
      "res07",
      "res08",
      "res09",
      "res10",
      "res11",
      "res12",
      "res13",
      "res14",
      "res15",
      "res21",
      "res22",
      "office06",
    ].find((el) => el === category);
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.parent.data.subscribe((data) => {
        this.blocks = data.blocks;
        this.subscription.add(
          this.route.params.subscribe((params) => {
            this.projectKey = params["project_key"];
            this.block = this.blockHelper.filterBlocksByKey(
              this.blocks,
              this.projectKey
            );

            this.setTitle(this.block.properties.title);

            this.blocksService
              .getBlocks(this.projectKey, this.isProjectLocal(this.projectKey))
              .then((blocks) => {
                this.sliders = blocks.filter((obj) => {
                  return obj.key.startsWith("slider");
                });
              });
          })
        );
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
